import Vue from 'vue'

// key-value
import key from '../config/key-value.js'

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

// 类型状态过滤器，要保证引用keyFilter时component和filterKey与key-value.js中的值一致
Vue.filter('keyFilter', function (value, component, filterKey, obj, oParam) {
  let result = value
  let params = ''
  if (obj) {
    // 传后台数组数据进来。直接使用。oParam是对应接口的key和value名称
    obj.map(function (item) {
      if (item[oParam.oKey] === value) {
        result = item[oParam.oValue]
      }
    })
  } else {
    if (!key[component]) {
      // console.log('未识别组件名 ' + component)
    } else if (!key[component][filterKey]) {
      // console.log('未识别键名 ' + filterKey)
    } else {
      key[component][filterKey].map(function (item) {
        if (item.id === value) {
          result = item.name
          params = item.params ? item.params : ''
        }
      })
    }
  }

  // return result;   // 没返回其他信息，params属性就形同虚设了
  return {
    name: result, // 页面展示信息，常用
    params: params, // 其他信息，例如标签颜色
  }
})

// 传后台数组数据进来。直接使用。oParam是对应接口的key和value名称
Vue.filter('reqFilter', function (value, obj, oParam) {
  let result = value
  let params = ''
  if (obj) {
    // 传后台数组数据进来。直接使用。oParam是对应接口的key和value名称
    obj.map(function (item) {
      if (item[oParam.oKey] === value) {
        result = item[oParam.oValue]
      }
    })
  }
  return {
    name: result, // 页面展示信息，常用
    params: params, // 其他信息，例如标签颜色
  }
})
// 格式化时间24:59:59 时分秒
Vue.filter('timeFormat', function (value, format) {
  if (!value) { return '暂无' }
  if (format !== '00:00:00') {
    return
  }
  let time = new Date(value)
  let hours = time.getHours()
  let minutes = time.getMinutes()
  let seconds = time.getSeconds()
  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  return `${hours}:${minutes}:${seconds}`
})
